<!-- Start Page Header -->
<div class="page-header">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2 class="entry-title">{{'Quote' | translate}}</h2>
                <div class="breadcrumb">
                    <span>{{'here' | translate}} : </span>
                    <a routerLink="/Home"> {{'home' | translate}} </a>
                    <span class="crumbs-spacer"><i class="fa fa-angle-double-right"></i></span>
                    <span class="current"> {{'Quote' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page Header -->

<!-- Start Content Section -->
<section id="content">
    <div class="container">
        <div class="row">
            <div class="col-md-9">
                <h2 class="big-title">{{'QuoteForm' | translate}}</h2>

                <!-- Start Contact Form -->
                <form role="form" id="contactForm" class="contact-form" data-toggle="validator" class="shake">
                    <div class="form-group">
                        <div class="controls">
                            <input type="text" id="name" class="form-control" placeholder="{{'Name' | translate}}" required
                                data-error="Please enter your name">
                            <div class="help-block with-errors"></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="controls">
                            <input type="email" class="email form-control" id="email" placeholder="{{'Email' | translate}}" required
                                data-error="Please enter your email">
                            <div class="help-block with-errors"></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="controls">
                            <input type="text" id="msg_JobTitle" class="form-control" placeholder="{{'JobTitle' | translate}}" required
                                data-error="Please enter your  Job Title">
                            <div class="help-block with-errors"></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="controls">
                            <input type="text" id="msg_Company" class="form-control" placeholder="{{'CompanyName' | translate}}" required
                                data-error="Please enter your  Company Name">
                            <div class="help-block with-errors"></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="controls">
                            <input type="text" id="msg_Mobile" class="form-control" placeholder="{{'Mobile' | translate}}" required
                                data-error="Please enter your Mobile">
                            <div class="help-block with-errors"></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="controls">
                            <input type="text" id="msg_Subject" class="form-control" placeholder="{{'Subject' | translate}}" required
                                data-error="Please enter your  Subject">
                            <div class="help-block with-errors"></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="controls">

                            <div>
                                <input type="checkbox" checked>
                            </div>
                            <textarea id="message" rows="7" placeholder="{{'Describtion' | translate}} " class="form-control" required
                                data-error="Write your Describtion "></textarea>

                            <div class="help-block with-errors"></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="controls">
                            <div class="panel panel-default">
                                <div class="panel-heading">{{'UploadFiles' | translate}}</div>
                                <div class="panel-body ">
                                    <div class="input-group">

                                        <input type="file" id="File" placeholder="CV " class="form-control " multiple
                                            required data-error="Choose Your CV " />
                                        <span class="input-group-btn">
                                            <button type="button" id="Uplode" class="btn btn-effect "> {{'Upload' | translate}}</button>
                                        </span>
                                    </div><!-- /input-group -->


                                    <br />
                                    <table class="table table-striped table-bordered table-hover table-responsive"
                                        id="UplodTable" style="display:none">
                                        <thead>
                                            <tr>
                                                <th style="display:none">ID</th>
                                                <th>{{'Name' | translate}}</th>
                                                <th>{{'size' | translate}}</th>
                                                <th>{{'Type' | translate}}</th>
                                                <th>{{'LastModified' | translate}}</th>
                                                <th>{{'Progress' | translate}}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                    </table>

                                </div>

                            </div>

                            <div class="help-block with-errors"></div>
                        </div>
                    </div>
                    <button type="submit" id="submit" class="btn btn-effect"><i class="fa fa-check"></i> {{'Sendrequest' | translate}}</button>
                    <div id="msgSubmit" class="h3 text-center hidden"></div>
                    <div class="clearfix">
                    </div>

                </form>
                <!-- End Contact Form -->

            </div>
            <div class="col-md-3">
                <h3 class="small-title ">{{'QuoteDescription' | translate}}</h3>
                <div class="information">
                    <div class="contact-datails">
                        <p id="JobDescription">
                            {{'QDes' | translate}}<br />
                            1.{{'QDes1' | translate}}<br />
                            2.{{'QDes2' | translate}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Content Section  -->